import {
  Alert, AlertIcon, AlertTitle, AlertDescription, useColorModeValue,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";
import { pendingNewHirePathById } from "helpers/url/pages/v1";

interface PendingNewHireAlertBannerProps {
  newHireId: string;
}

export function PeopleTeamPendingNewHireAlertBanner({ newHireId }: PendingNewHireAlertBannerProps) {
  const alertTextColor = useColorModeValue("fg.subtle", "inherit");
  return (
    <RouterLink to={pendingNewHirePathById(newHireId)}>
      <Alert status="warning" borderTopRadius="10px">
        <AlertIcon />
        <AlertTitle color={alertTextColor}>This new hire is pending!</AlertTitle>
        <AlertDescription color={alertTextColor}>
          Visit the pending new hire page to add additional information and kick off the automations.
        </AlertDescription>
      </Alert>
    </RouterLink>
  );
}

export function NotPeopleTeamPendingNewHireAlertBanner({ newHireId }: PendingNewHireAlertBannerProps) {
  const alertTextColor = useColorModeValue("fg.subtle", "inherit");
  return (
    <Alert status="warning" borderTopRadius="10px">
      <AlertIcon />
      <AlertTitle color={alertTextColor}>This new hire is pending!</AlertTitle>
      <AlertDescription color={alertTextColor}>
        This New Hire&apos;s onboarding has not been started. Please reach out to the People Team to kick their onboarding off.
      </AlertDescription>
    </Alert>
  );
}
